(function () {
  function sendGA4Event(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  }

  // --- 1. Navigation clicks ---
  function initNavigationTracking() {
    document.addEventListener('click', function (e) {
      const link = e.target.closest('a');
      if (!link) return;

      // Only track links inside the header/nav areas
      const inNav = link.closest('.header-wrapper') || link.closest('menu-drawer') || link.closest('header-drawer') || link.closest('mega-menu-dropdown') || link.closest('.mega-menu__content');
      if (!inNav) return;

      // Exclude cart and account icon buttons
      if (link.closest('.header__icons')) return;

      let navType = 'header';
      if (link.closest('menu-drawer') || link.closest('header-drawer')) {
        navType = 'mobile_drawer';
      } else if (link.closest('.mega-menu__content') || link.closest('mega-menu-dropdown')) {
        navType = 'desktop_mega_menu';
      } else if (link.closest('.header-nav') || link.closest('.header__inline-menu')) {
        navType = 'desktop_nav';
      }

      sendGA4Event('navigation_click', {
        link_text: (link.innerText || link.getAttribute('aria-label') || '').trim(),
        link_url: link.href,
        nav_type: navType,
      });
    });
  }

  // --- 2. Filter & sort clicks ---
  function getFilterInfo(input) {
    // Value: from the visible label text
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const filterValue = label
      ? (label.querySelector('.facet-checkbox__text-label')?.innerText.trim() || label.innerText.trim().split('\n')[0].trim())
      : input.value;

    // Category name: try details > .facet-toggle span (standard facets)
    let filterName = '';
    const details = input.closest('details');
    if (details) {
      const span = details.querySelector('.facet-toggle span:first-child');
      if (span) filterName = span.innerText.trim();
    }

    // Fallback: fieldset aria-label (size filter)
    if (!filterName) {
      const fieldset = input.closest('fieldset');
      if (fieldset) {
        filterName = (fieldset.getAttribute('aria-label') || '').split('(')[0].trim();
      }
    }

    // Last resort: parse from input name attribute
    if (!filterName) {
      const parts = input.name.split('.');
      filterName = parts[parts.length - 1].replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    return { filterName, filterValue };
  }

  function initFilterTracking() {
    document.addEventListener('input', function (e) {
      if (!e.target.closest('facet-filters-form')) return;
      const input = e.target;
      if (input.type !== 'checkbox' && input.type !== 'radio') return;

      const { filterName, filterValue } = getFilterInfo(input);

      sendGA4Event('filter_apply', {
        filter_name: filterName,
        filter_value: filterValue,
        filter_action: input.checked ? 'add' : 'remove',
      });
    });

    document.addEventListener('change', function (e) {
      if (e.target.id !== 'SortBy') return;
      sendGA4Event('sort_apply', {
        sort_by: e.target.value,
      });
    });
  }

  // --- 3. Collection product & variant clicks ---
  function getProductTitleFromCard(card) {
    const link = card.querySelector('a[title]');
    return link ? link.getAttribute('title') : '';
  }

  function initCollectionTracking() {
    document.addEventListener('click', function (e) {
      const card = e.target.closest('product-card');
      if (!card) return;

      // Colour swatch click
      const swatchLink = e.target.closest('[data-colour-swatch]');
      if (swatchLink) {
        const img = swatchLink.querySelector('img');
        sendGA4Event('collection_variant_click', {
          product_title: img ? img.alt : getProductTitleFromCard(card),
          product_url: swatchLink.href,
          click_type: 'variant_swatch',
        });
        return;
      }

      // Quickview click
      const quickview = e.target.closest('product-quickview-button');
      if (quickview) {
        sendGA4Event('collection_product_click', {
          product_title: getProductTitleFromCard(card),
          product_url: (quickview.dataset.url || '').split('?')[0],
          click_type: 'quickview',
        });
        return;
      }

      // Regular product card link (image link or title link)
      const productLink = e.target.closest('a[title]');
      if (productLink) {
        sendGA4Event('collection_product_click', {
          product_title: productLink.getAttribute('title') || productLink.innerText.trim(),
          product_url: productLink.href,
          click_type: 'product_card',
        });
      }
    });
  }

  // --- 4. PDP accordion clicks ---
  function initAccordionTracking() {
    if (typeof window.toggleAccordion !== 'function') return;

    const original = window.toggleAccordion;
    window.toggleAccordion = function (index) {
      const content = document.getElementById('accordion-content-' + index);
      const isOpening = content && content.classList.contains('hidden');

      const container = content ? content.closest('.product-accordion') : null;
      const heading = container ? container.querySelector('h4') : null;

      sendGA4Event('accordion_click', {
        accordion_title: heading ? heading.innerText.trim() : String(index),
        accordion_action: isOpening ? 'open' : 'close',
        product_title: document.title,
      });

      original(index);
    };
  }

  initNavigationTracking();
  initFilterTracking();
  initCollectionTracking();
  initAccordionTracking();
})();

